import request from '@/utils/request'

// 兼容后端可能返回的三种列表结构：
// 1) res.data 直接是数组，total/records 在 res 顶层
// 2) res.data = { total, records, data: [...] } 嵌套结构
// 3) res.data = { "0": {...}, "1": {...} } 数字键对象（非真数组）
function normalizeListResponse(res) {
  let dataArray = res.data

  if (!Array.isArray(dataArray) && dataArray && typeof dataArray === 'object') {
    if (Array.isArray(dataArray.data)) {
      // 情况 2：嵌套结构
      const inner = dataArray
      return {
        data: inner.data,
        total: Number(inner.total || inner.records || res.total || res.records || 0)
      }
    }
    // 情况 3：数字键对象，按 key 排序后转数组
    const numericKeys = Object.keys(dataArray).filter(k => !isNaN(k))
    dataArray = numericKeys.length > 0
      ? numericKeys.sort((a, b) => Number(a) - Number(b)).map(k => dataArray[k])
      : []
  }

  if (!Array.isArray(dataArray)) dataArray = []

  return {
    data: dataArray,
    total: Number(res.total || res.records || 0)
  }
}

// 查询处理人员列表
export function listAlarmHandlers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.listAlarmHandlers',
      method: 'get',
      params: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(normalizeListResponse(res))
      } else {
        reject(new Error(res.msg || '获取处理人员列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增处理人员（批量）
export function saveAlarmHandlers(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.saveAlarmHandler',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增处理人员失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 变更处理人员
export function updateAlarmHandler(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.updateAlarmHandler',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '变更处理人员失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除处理人员
export function deleteAlarmHandler(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.deleteAlarmHandler',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除处理人员失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
